import { FormEvent, useContext, useEffect, useState } from 'react';

import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import blackAndWhiteLaptop from '../../assets/images/black-and-white-laptop-prateek-katyal.jpeg';
import Button from '../../components/atoms/button';
import Input from '../../components/atoms/input';
import Page from '../../components/page-layout/Page';
import AuthService from '../../services/authService';
//import { codeAdmin, codeStudent } from '../../utils/authenticationCodes';
import ModalContext from '../../utils/ModalContext';

const INPUT_FIELDS = {
  firstName: {
    required: true,
    autoFocus: true,
    autoComplete: 'given-name',
    id: 'first-name',
    label: 'First name',
    type: 'text',
    placeholder: 'Enter first name',
  },
  lastName: {
    required: true,
    autoFocus: true,
    autoComplete: 'family-name',
    id: 'last-name',
    label: 'Last name',
    type: 'text',
    placeholder: 'Enter last name',
  },
  email: {
    required: true,
    autoComplete: 'email',
    id: 'email',
    label: 'Email',
    placeholder: 'Enter email address',
    type: 'email',
  },
  password: {
    required: true,
    autoComplete: 'new-password',
    id: 'password',
    label: 'Password',
    type: 'password',
    placeholder: 'Enter password',
  },
  code: {
    required: true,
    autoComplete: '',
    id: 'code',
    label: 'Activation code',
    type: 'text',
    placeholder: 'CODE',
  },
};

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userAgreementConsent, setUserAgreementConsent] = useState(false);
  const [researchConsent, setResearchConsent] = useState(false);
  //const [code, setCode] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectTo');

  const { showAlertModal, showAgreementModal } = useContext(ModalContext);

  useEffect(() => {
    document.title = 'Fordonsdalen Create admin account';
  });

  function verifyForm() {
    /*if (code !== codeAdmin && code !== codeStudent) {
      showAlertModal('The activation code is invalid');
      return false;
    }*/
    return true;
  }

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!verifyForm()) return;
    if (!userAgreementConsent) return;

    setIsDisabled(true);
    const credentials = { email, password, researchConsent };
    AuthService.createAccount(credentials)
      .then(() => navigate(redirectTo || '/'))
      .catch(error => onFailure(error));
  }

  function onFailure(error: any) {
    console.error('Error', error);
    showAlertModal(error.message);
    setIsDisabled(false);
  }

  return (
    <Page
      className="register dual-hero-form"
      padding={false}
      breadcrumbs={[
        ['/', 'Home'],
        ['/register', 'Register'],
      ]}
    >
      <section className="column column-form">
        <form onSubmit={onSubmit} className="form">
          <h1 className="title">Welcome!</h1>
          <p className="subtitle">Please enter your details</p>
          <Input className="mb-4" {...INPUT_FIELDS.email} state={[email, setEmail]} />
          <Input className="mb-4" {...INPUT_FIELDS.password} state={[password, setPassword]} />
          <div className="flex flex-wrap items-center mb-4">
            <input
              className="mr-2"
              id="user-agreement-consent"
              type="checkbox"
              checked={userAgreementConsent}
              onChange={e => setUserAgreementConsent(e.target.checked)}
              required
            />
            <label className="!font-normal" htmlFor="consent">
              I have read and accepted the{' '}
            </label>
            &nbsp;
            <button onClick={() => showAgreementModal(0)} type="button" className="link-button">
              user agreement
            </button>
          </div>
          <div className="flex flex-wrap items-center mb-4">
            <input
              className="mr-2"
              id="researchConsent"
              type="checkbox"
              checked={researchConsent}
              onChange={e => setResearchConsent(e.target.checked)}
            />
            <label className="!font-normal" htmlFor="consent">
              I hereby consent to sharing my data in the{' '}
            </label>
            &nbsp;
            <button onClick={() => showAgreementModal(1)} type="button" className="link-button">
              research on lifelong learning
            </button>
          </div>
          <Button className="button mb-7 w-full" disabled={isDisabled} type="submit">
            Create account
          </Button>
          <p className="text-center">
            {' '}
            Already have an account?{' '}
            <Link
              className="link-button"
              to={{
                pathname: '/signin',
                search: redirectTo ? `?redirectTo=${redirectTo}` : undefined,
              }}
            >
              Sign In
            </Link>
          </p>
        </form>
      </section>

      <section className="column column-hero">
        <div className="hero">
          <img src={blackAndWhiteLaptop} alt="A laptop on a table next to a sign which reads 'You got this'" />
        </div>
      </section>
    </Page>
  );
}
